import { useForm } from "react-hook-form";

import type { Form } from "@/features/forms/models";

export const useDynamicForm = (dynamicForm?: Form) => {
  const form = useForm({
    values: dynamicForm?.fields.reduce(
      (acc, { id, value }) => ({
        ...acc,
        [id]: value ?? undefined,
      }),
      {},
    ),
  });

  return form;
};
